import React from 'react';
import './styles.scss';

const ColorIcon = ({color = '#fff'}) => {
  return (
    <div className='priorization-color-icon' style={{'backgroundColor': color}} />
  );
};

export default ColorIcon;
